<template>
	<div class="white">
		<v-container
			v-if="library"
			:style="$vuetify.breakpoint.mdAndUp ? 'margin-bottom: 20px;' : 'padding-bottom: calc(90/728 * 100vw + 20px);'"
		>
			<v-row justify="center">
				<v-col
					cols="12"
					md="4"
					:style="$vuetify.breakpoint.mdAndUp ? 'position: sticky; top: 36px; height: max-content;' : ''"
				>
					<v-row>
						<v-col cols="12">
							<v-img
								contain
								:src="library.coverPic"
								class="grey lighten-3 mx-auto"
								:aspect-ratio="1/1.4"
								max-width="500"
								@click="showCover = false"
							>
								<template #placeholder>
									<v-row class="fill-height ma-0" align="center" justify="center">
										<v-progress-circular indeterminate color="primary"></v-progress-circular>
									</v-row>
								</template>

								<template #default>
									<v-img :src="library.coverPic" class="stretch" :aspect-ratio="1/1.4"></v-img>
								</template>
							</v-img>
						</v-col>
						
						<v-col cols="auto" class="ma-0 py-0 text-start">
							<span>
								<v-tooltip bottom>
									<template #activator=" {on} ">
										<span v-on="on">
											<v-icon right>mdi-calendar</v-icon>
											{{ library.publishDateWrit }}
										</span>
									</template>
									<span v-if="library.publishDate">{{ library.publishDate.substring(0,10) }}</span>
									<span v-else>غير منشور</span>
								</v-tooltip>
							</span>
						</v-col>
						<v-spacer></v-spacer>
						<v-col cols="auto" class="ma-0 py-0 text-start">
							<v-icon right>mdi-pen</v-icon>
							<router-link :to="{ name: 'dashboard-profile', params: { id: library.userID } }">
								{{ library.userFullName }}
							</router-link>
						</v-col>
					</v-row>
					<v-divider></v-divider>
					<v-row>
						<v-col cols="12">
							<app-ad v-if="$vuetify.breakpoint.mdAndUp" key="middle" middle></app-ad>
							<app-ad v-else key="sticky" sticky-bottom></app-ad>
						</v-col>
					</v-row>
				</v-col>

				<v-col cols="12" md="8">
					<v-row class="text-center" dense>
						<v-col cols="12" class="text-start">
							<h3>{{ library.title }}</h3>
						</v-col>
						<v-col v-if="library.wrtier" cols="12" class="text-start">
							<v-chip outlined>
								<v-icon left>mdi-account-edit</v-icon>
								{{ library.wrtier }}
							</v-chip>
						</v-col>
						<v-col cols="12" class="text-start text-no-wrap overflow-x-auto">
							<v-chip outlined class="mx-1 white--text" color="green">
								<v-icon left>mdi-bookshelf</v-icon>
								<div>{{ library.type }}</div>
							</v-chip>

							<span v-if="configViewCount" class="ps-3">{{ library.viewCount }}</span>
							<v-icon v-if="configViewCount" left>mdi-eye</v-icon>
						</v-col>

						<v-col cols="12">
							<v-row class="text-start">
								<v-col cols="12">
									<pre wrap>{{ library.description }}</pre>
								</v-col>

								<v-col v-if="library.communications.length" cols="12">
									<b>بيانات التواصل:</b>
									
									<v-row dense class="pt-2 pb-4">
										<v-col cols="12">
											<v-divider></v-divider>
										</v-col>
									</v-row>
									
									<app-communication-list :communications="library.communications"></app-communication-list>
								</v-col>

								<v-col cols="12">
									<v-btn :href="library.link" target="_blank" color="primary">
										قراءة المصدر
										<v-icon right>mdi-open-in-new</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>

		<v-container v-if="missingRecord">
			<v-row justify="center">
				<v-col cols="12" sm="8" md="6" lg="4">
					<v-card>
						<v-card-title primary-title>
							<v-spacer></v-spacer>
							<div>الصفحة غير موجودة</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<v-row dense>
								<v-col cols="12" class="text-center">الرجاء التواصل مع الإدارة</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<v-dialog v-model="showCover">
			<v-container v-if="library" class="pa-0 fill-height">
				<v-img contain :src="library.coverPic" class="grey lighten-2" :style="getHeight">
					<v-row class="pa-0 white--text fill-height">
						<v-col class="text-left pa-0 pt-1 pl-4" cols="12">
							<v-btn
								:small="$vuetify.breakpoint.xsOnly"
								class="primary"
								rounded
								icon
								@click="showCover = false"
							>
								<v-icon color="white">mdi-close</v-icon>
							</v-btn>
						</v-col>
						<v-col class="text-center" cols="12" align-self="end">
							<a :href="library.coverPic" download target="_blank">
								<v-btn :small="$vuetify.breakpoint.xsOnly" class="primary" rounded>تحميل</v-btn>
							</a>
						</v-col>
					</v-row>
				</v-img>
			</v-container>
		</v-dialog>

		<app-social-sharing
			v-if="library"
			:id="$route.params.recordID"
			type="library"
			:content="{ url: library.url, title: library.title, description: library.note }"
			:style="$vuetify.breakpoint.mdAndUp ? '' : 'margin-bottom: calc(90/728 * 100vw);'"
		></app-social-sharing>
	</div>
</template>

<script>
import client from "@/client";
import { addBaseURL } from "@/utils/baseURL";

export default {
	components: {
		"app-ad": require("@/components/general/AppAd").default,
		"app-communication-list": () => import(/* webpackChunkName: "app-communication-list" */ "@/components/content/AppCommunicationList"),
		"app-social-sharing": require("@/components/general/AppSocialSharing")
			.default
	},
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			library: null,
			infoHeaders: [
				{ text: "المدينة", value: "cityName" },
				{ text: "المكان", value: "placeName" },
				{ text: "وصف المكان", value: "locationDetails" },
				{ text: "تاريخ البدء", value: "startDate" },
				{ text: "تاريخ الإنتهاء", value: "endDate" },
				{ text: "وقت البدء", value: "startTime" },
				{ text: "وقت الانتهاء", value: "endTime" },
				{ text: "الوصف", value: "description" }
			],

			galleryHeaders: [
				{ text: "الاسم", value: "name" },
				{ text: "الوصف", value: "description" },
				{ text: "تحميل", value: "download" }
			],
			contactHeaders: [
				{ text: "الاسم", value: "name" },
				{ text: "الوصف", value: "note" },
				{ text: "تواصل", value: "icon" }
			],
			showLimited: true,
			missingRecord: false,
			showCover: false
		};
	},
	computed: {
		getHeight() {
			var height = window.innerHeight - 100;
			return "height: " + height + "px;";
		},
		configViewCount() {
			return this.$store.state.viewCount;
		}
	},
	mounted() {
		this.getLibrary();
	},
	methods: {
		getLibrary() {
			client
				.get("/api/library/show/" + this.$route.params.recordID, {})
				.then(response => {
					console.log(response);
					var newData = response.data.data;
					newData.coverPic = addBaseURL(newData.coverPic);

					newData.url = location.href;

					this.library = newData;
				})
				.catch(err => {
					this.missingRecord = true;
					console.log(err);
				});
		}
	}
};
</script>

<style scoped>
.v-dialog__content ::v-deep .v-dialog {
	width: auto;
}
</style>